import React, { Component } from "react";
import axios from "axios";
import { v4 as uuid } from "uuid";
import Team from "./Team";
const config = require("../config.json");

export default class TeamAdmin extends Component {
  constructor(props) {
    super(props);
    this.handleInputChange = this.handleInputChange.bind(this);
  }
  state = {
    isEditMode: false,
    newTeam: {
      teamName: "",
      teamCode: "",
      teamOrganization: "",
      id: uuid(),
      members: [],
      campaignId: "",
      kgCO2: 0,
      points: { totalPoints: 0, weekPoints: {} },
      avgTotalPoints: 0,
    },
    teams: [],
    shownTeams: [],
    organizations: [],
    campaigns: [],
  };

  handleAddTeam = async (team, event) => {
    event.preventDefault();
    team.teamOrganization = document.getElementById("companies").value;
    try {
      const params = {
        id: team.id,
        teamName: team.teamName,
        teamCode: team.teamCode,
        teamOrganization: team.teamOrganization,
        campaignId: team.teamOrganization
          ? this.state.organizations.find((organization) => {
              return team.teamOrganization === organization.id;
            }).campaignId
          : "N/A",
        teamOrganizationName: team.teamOrganization
          ? this.state.organizations.find((organization) => {
              return team.teamOrganization === organization.id;
            }).companyName
          : "N/A",
        members: [],
        points: { totalPoints: 0, weekPoints: {} },
        avgTotalPoints: 0,
        kgCO2: 0,
        weekAvgTotalPoints: {},
      };

      await axios.post(`${config.api.invokeUrl}/teams/${team.id}`, params);
      this.setState({
        teams: [...this.state.teams, this.state.newTeam],
      });
      this.setState({
        newTeam: {
          teamName: "",
          teamCode: "",
          teamOrganization: "",
          id: uuid(),
          members: [],
          campaignId: "",
          kgCO2: 0,
          points: { totalPoints: 0, weekPoints: {} },
          avgTotalPoints: 0,
          weekAvgTotalPoints: {},
        },
      });
    } catch (err) {
      console.log(err);
    }
  };

  handleUpdateTeam = async (team) => {
    try {
      const params = {
        ...team,
        league: team.league ? team.league : "N/A",
      };
      await axios.patch(`${config.api.invokeUrl}/teams/${team.id}`, params);
    } catch (err) {
      console.log(err);
    }
    const updatedTeams = [...this.state.teams].filter((c) => c.id !== team.id);
    updatedTeams.push(team);
    this.setState({ teams: updatedTeams });
  };

  handleDeleteTeam = async (id, event) => {
    event.preventDefault();
    if (window.confirm("Dette vil slette holdet for evigt. Er du sikker?")) {
      try {
        await axios.delete(`${config.api.invokeUrl}/teams/${id}`);
      } catch (err) {
        console.log(err);
      }
      const updatedTeams = [...this.state.teams].filter(
        (team) => team.id !== id
      );
      this.setState({ teams: updatedTeams });
    }
  };

  fetchTeams = async () => {
    try {
      const res = await axios.get(`${config.api.invokeUrl}/teams`);
      const teams = res.data;
      teams.sort((teama, teamb) => teamb.members.length - teama.members.length);
      this.setState({ teams: teams, shownTeams: teams });
    } catch (err) {
      console.log(err);
    }
  };

  fetchCampaigns = async () => {
    try {
      const res = await axios.get(`${config.api.invokeUrl}/campaign/active`);
      const campaigns = res.data;
      this.setState({ campaigns: campaigns });
    } catch (err) {
      console.log(err);
    }
  };

  filterTeams = (campaignId, teams) => {
    if (campaignId) {
      return teams.filter((t) => t.campaignId == campaignId);
    } else return teams;
  };

  fetchCompanies = async () => {
    try {
      const res = await axios.get(`${config.api.invokeUrl}/companies`);
      const organizations = res.data;
      this.setState({ organizations: organizations });
    } catch (err) {
      console.log(err);
    }
  };

  handleInputChange(event) {
    const value = event.target.value;
    const name = event.target.name;
    this.setState({
      newTeam: {
        ...this.state.newTeam,
        [name]: value,
      },
    });
  }

  componentDidMount = () => {
    this.fetchAll();
  };

  fetchAll = async () => {
    this.setState({ loading: true });
    let promise = await Promise.all([
      this.fetchCampaigns(),
      this.fetchCompanies(),
      this.fetchTeams(),
    ]);
    this.setState({ loading: false });
  };

  render() {
    return (
      <>
        <section className="section">
          <div className="container">
            <h1>Hold Admin</h1>
            <p className="subtitle is-5">Tilføj og fjern hold</p>
            <br />
            <div className="rows">
              <div className="row">
                <form
                  onSubmit={(event) =>
                    this.handleAddTeam(this.state.newTeam, event)
                  }
                >
                  <div className="field">
                    Sorter efter kampagne (obs holdet ryger stadig i
                    Organisationens kampagne)
                    <div className="control">
                      <select
                        className="select is-medium"
                        name="campaigns"
                        id="campaigns"
                        onChange={() => {
                          const select = document.getElementById("campaigns");
                          const filteredTeams = this.filterTeams(
                            select.options[select.selectedIndex].value,
                            this.state.teams
                          );
                          this.setState({ shownTeams: filteredTeams });
                        }}
                      >
                        <option key={1} value={""}>
                          Alle
                        </option>
                        {this.state.campaigns.map((campaign) => {
                          return (
                            <option key={campaign.id} value={campaign.id}>
                              {campaign.campaignName}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                    <div className="control">
                      <input
                        className="input is-medium"
                        type="text"
                        placeholder="Indtast navn"
                        value={this.state.newTeam.teamName}
                        onChange={this.handleInputChange}
                        name="teamName"
                      />
                    </div>
                    <div className="control">
                      <input
                        className="input is-medium"
                        type="text"
                        placeholder="Indtast kode"
                        value={this.state.newTeam.teamCode}
                        onChange={this.handleInputChange}
                        name="teamCode"
                      />
                    </div>
                    <div className="control">
                      <select
                        className="select is-medium"
                        onChange={this.handleInputChange}
                        name="teamOrganization"
                        id="companies"
                      >
                        {this.state.organizations.map((organization) => {
                          return (
                            <option
                              key={organization.id}
                              value={organization.id}
                            >
                              {organization.companyName}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                    <div className="control">
                      <button
                        type="submit"
                        className="button is-primary is-medium"
                      >
                        Tilføj
                      </button>
                    </div>
                  </div>
                </form>
              </div>
              <div className="row">
                {this.state.shownTeams.map((team) => (
                  <Team
                    key={team.id}
                    team={team}
                    organization={
                      this.state.organizations.find((organization) => {
                        return team.teamOrganization === organization.id;
                      })
                        ? this.state.organizations.find((organization) => {
                            return team.teamOrganization === organization.id;
                          }).companyName
                        : "N/A"
                    }
                    handleDeleteTeam={this.handleDeleteTeam}
                    handleUpdateTeam={this.handleUpdateTeam}
                  ></Team>
                ))}
              </div>
            </div>
          </div>
        </section>
      </>
    );
  }
}
